import api from "@/lib/api";
import { setStoredClientId } from "@/lib/clientSelection";

const VISOR_RETURN_TO_KEY = "vf:visor_return_to";

/** Rutas válidas para volver a confronta tras cerrar el visor. */
export function isConfrontaReturnPath(path) {
  const p = String(path || "").trim();
  if (!p.startsWith("/")) return false;
  return (
    p.startsWith("/confronta-cfdi") ||
    p.startsWith("/confronta-egresos") ||
    p.startsWith("/confronta-nominas") ||
    p === "/confronta" ||
    p.startsWith("/confronta?")
  );
}

/**
 * Navega al visor SAT fijo correcto (ingresos / egresos / nóminas) y deja parámetros
 * `focusUuid` para que la pantalla abra el detalle y ajuste mes/año.
 *
 * @param {import("react-router-dom").NavigateFunction} navigate
 * @param {string} clientId cliente activo en la confronta
 * @param {string} uuid UUID del CFDI
 * @param {{ alternateClientId?: string, returnTo?: string }} [opts]
 */
export async function goToSatVisorForUuid(navigate, clientId, uuid, opts = {}) {
  const { alternateClientId, returnTo } = opts;
  const cid = (alternateClientId || clientId || "").trim();
  const u = (uuid || "").trim().toUpperCase();
  if (!cid || !u) {
    throw new Error("Cliente o UUID inválido");
  }

  const { data } = await api.get("/cfdi/by-uuid", { params: { client_id: cid, uuid: u } });
  const realClient = (data.client_id || cid || "").trim();

  if (realClient) {
    setStoredClientId(realClient);
  }

  let open = "ingresos";
  const tipo = (data.tipo_comprobante || "").toUpperCase();
  const direccion = (data.direccion || "").toLowerCase();
  if (tipo === "N") {
    open = "nominas";
  } else if (direccion === "recibido") {
    open = "egresos";
  }

  const refDate =
    tipo === "P"
      ? String(data.fecha_pago || data.fecha || "").slice(0, 10)
      : String(data.fecha || "").slice(0, 10);
  let y = data.year;
  let mes = "";
  if (refDate && refDate.length >= 10) {
    y = parseInt(refDate.slice(0, 4), 10);
    mes = refDate.slice(5, 7);
  }
  if (!y || Number.isNaN(y)) {
    y = new Date().getFullYear();
  }

  const params = new URLSearchParams();
  params.set("open", open);
  params.set("focusUuid", u);
  params.set("focusYear", String(y));
  if (mes) params.set("focusMes", mes);
  if (realClient) params.set("focusClient", realClient);

  const back = (returnTo || "").trim();
  if (isConfrontaReturnPath(back)) {
    try {
      sessionStorage.setItem(VISOR_RETURN_TO_KEY, back);
    } catch {
      /* ignore */
    }
  } else {
    clearVisorReturnTo();
  }

  navigate(`/visores-sat?${params.toString()}`, {
    state: back ? { returnTo: back } : undefined,
  });
}

/** Ruta guardada al abrir el visor desde confronta (o cadena vacía). */
export function peekVisorReturnTo() {
  try {
    return sessionStorage.getItem(VISOR_RETURN_TO_KEY) || "";
  } catch {
    return "";
  }
}

export function clearVisorReturnTo() {
  try {
    sessionStorage.removeItem(VISOR_RETURN_TO_KEY);
  } catch {
    /* ignore */
  }
}
